var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramSankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 296C608 283 597 272 584 272H56C43 272 32 283 32 296S43 320 56 320H178L267 468C272 476 280 480 288 480H584C597 480 608 469 608 456S597 432 584 432H302L234 320H584C597 320 608 309 608 296ZM56 240H248C256 240 264 236 269 228L358 80H584C597 80 608 69 608 56S597 32 584 32H344C336 32 328 36 323 44L234 192H56C43 192 32 203 32 216S43 240 56 240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramSankey);
export default __webpack_public_path__ + "static/media/diagram-sankey.71f251868e92cdafe0ac6c32f0b18f55.svg";
export { ForwardRef as ReactComponent };